export default function TypeFiltersState({ t, type }) {
  const filtersInitialState = {
    currentFilters: {
      type: '',
      subtypes: [],
    },
    // July 9, 2019 Error Message -> {"code":400,"message":"query param conclusionType must be one of [FACT, GENDER, NAME, ALTERNATE_NAME]"}
    // MJV: translation
    conclusionType: {
      label: t('conclusionType', 'Conclusion Type'),
      isOpen: false,
      accordionItems: {
        fact: { label: t('user.fact', 'Fact'), value: 'FACT', isChecked: false },
        gender: { label: t('gender.label', 'Gender'), value: 'GENDER', isChecked: false },
        name: { label: t('name', 'Name'), value: 'NAME', isChecked: false },
        alternateName: { label: t('name.alternate', 'Alternate Name'), value: 'ALTERNATE_NAME', isChecked: false },
      },
    },
    // July 9, 2019 Error Message -> {"code":400,"message":"query param factType must be one of [BIRTH, CHRISTENING, DEATH, BURIAL, STILLBIRTH, BAR_MITZVAH, BAT_MITZVAH,
    // IMMIGRATION, MILITARY_SERVICE, NATURALIZATION, RESIDENCE, RELIGION, OCCUPATION, CREMATION, CASTE, NATIONAL_ID, NATIONALITY, PHYSICAL_DESCRIPTION, ETHNICITY,
    // AFFILIATION, DIED_BEFORE_EIGHT, LIFE_SKETCH, NEVER_MARRIED, NO_CHILDREN, TITLE_OF_NOBILITY, TRIBE_NAME, ANNULMENT, COMMON_LAW_MARRIAGE, DIVORCE, MARRIAGE,
    // ADOPTIVE_PARENT, BIOLOGICAL_PARENT, FOSTER_PARENT, GUARDIAN_PARENT, STEP, USER_DEFINED]"}
    factType: {
      label: t('factType', 'Fact Type'),
      isOpen: false,
      accordionItems: {
        birth: { label: t('birth', 'Birth'), value: 'BIRTH', isChecked: false },
        christening: { label: t('christening', 'Christening'), value: 'CHRISTENING', isChecked: false },
        death: { label: t('death', 'Death'), value: 'DEATH', isChecked: false },
        burial: { label: t('burial', 'Burial'), value: 'BURIAL', isChecked: false },
        stillBirth: { label: t('user.fact.stillBirth', 'Still Birth'), value: 'STILLBIRTH', isChecked: false },
        barMitzvah: { label: t('user.fact.barMitzvah', 'Bar Mitzvah'), value: 'BAR_MITZVAH', isChecked: false },
        batMitzvah: { label: t('user.fact.batMitzvah', 'Bat Mitzvah'), value: 'BAT_MITZVAH', isChecked: false },
        // This value used to end in a non-breaking space (U+00A0) — invisible in the editor, but
        // still encoded into the `subtype` query param, so the API rejected the whole request with
        // the 400 documented above and the Immigration filter never returned results. See DATA-12263.
        immigration: { label: t('user.fact.immigration', 'Immigration'), value: 'IMMIGRATION', isChecked: false },
        militaryService: {
          label: t('user.fact.militaryService', 'Military Service'),
          value: 'MILITARY_SERVICE',
          isChecked: false,
        },
        naturalization: {
          label: t('user.fact.naturalization', 'Naturalization'),
          value: 'NATURALIZATION',
          isChecked: false,
        },
        residence: { label: t('user.fact.residence', 'Residence'), value: 'RESIDENCE', isChecked: false },
        affiliation: { label: t('user.fact.affiliation', 'Affiliation'), value: 'AFFILIATION', isChecked: false },
        diesBeforeEight: {
          label: t('user.fact.diedBeforeEight', 'Died Before Eight'),
          value: 'DIED_BEFORE_EIGHT',
          isChecked: false,
        },
        religion: { label: t('user.fact.religion', 'Religion'), value: 'RELIGION', isChecked: false },
        titleOfNobility: {
          label: t('user.fact.titleOfNobility', 'Title Of Nobility'),
          value: 'TITLE_OF_NOBILITY',
          isChecked: false,
        },
        occupation: { label: t('user.fact.occupation', 'Occupation'), value: 'OCCUPATION', isChecked: false },
        cremation: { label: t('user.fact.cremation', 'Cremation'), value: 'CREMATION', isChecked: false },
        caste: { label: t('user.fact.caste', 'Caste'), value: 'CASTE', isChecked: false },
        // clan: { label: t('user.fact.clan', 'Clan'), value: "CLAN", isChecked: false },
        nationalId: { label: t('user.fact.nationalId', 'National Id'), value: 'NATIONAL_ID', isChecked: false },
        nationality: { label: t('user.fact.nationality', 'Nationality'), value: 'NATIONALITY', isChecked: false },
        physicalDescription: {
          label: t('user.fact.physicalDescription', 'Physical Description'),
          value: 'PHYSICAL_DESCRIPTION',
          isChecked: false,
        },
        ethnicity: { label: t('user.fact.ethnicity', 'Ethnicity'), value: 'ETHNICITY', isChecked: false },
        tribeName: { label: t('user.fact.tribeName', 'Tribe Name'), value: 'TRIBE_NAME', isChecked: false },
        lifeSketch: { label: t('user.fact.lifeSketch', 'Life Sketch'), value: 'LIFE_SKETCH', isChecked: false },
        neverMarried: {
          label: t('user.fact.neverMarried', 'Never Married'),
          value: 'NEVER_MARRIED',
          isChecked: false,
        },
        noChildren: { label: t('user.fact.noChildren', 'No Children'), value: 'NO_CHILDREN', isChecked: false },
        annulment: { label: t('user.annulment', 'Annulment'), value: 'ANNULMENT', isChecked: false },
        commonLawMarriage: {
          label: t('user.fact.commonLawMarriage', 'Common Law Marriage'),
          value: 'COMMON_LAW_MARRIAGE',
          isChecked: false,
        },
        divorce: { label: t('user.fact.divorce', 'Divorce'), value: 'DIVORCE', isChecked: false },
        marriage: { label: t('marriage', 'Marriage'), value: 'MARRIAGE', isChecked: false },
        adoptiveParent: {
          label: t('user.fact.adoptiveParent', 'Adoptive Parent'),
          value: 'ADOPTIVE_PARENT',
          isChecked: false,
        },
        biologicalParent: {
          label: t('user.fact.biologicalParent', 'Biological Parent'),
          value: 'BIOLOGICAL_PARENT',
          isChecked: false,
        },
        fosterParent: {
          label: t('user.fact.fosterParent', 'Foster Parent'),
          value: 'FOSTER_PARENT',
          isChecked: false,
        },
        guardianParent: {
          label: t('user.fact.guardianParent', 'Guardian Parent'),
          value: 'GUARDIAN_PARENT',
          isChecked: false,
        },
        // step: { label: t('user.fact.step', 'Step'), value: "STEP", isChecked: false },
        // birthOrder: { label: t('user.fact.birthOrder', 'Birth Order'), value: "BIRTH_ORDER", isChecked: false },
        userDefined: { label: t('user.fact.userDefined', 'User Defined'), value: 'USER_DEFINED', isChecked: false },
      },
    },
    // July 9, 2019 Error message -> {"code":400,"message":"query param entityRefType must be one of [SOURCE, MATCHING_userA, NON_MATCHING_PERSONA,
    // REJECTED_SOURCE_HINT, MEMORY_PERSON, PHOTO, STORY, AUDIO, OBITUARY, DOCUMENT, PERSON_NOT_A_MATCH, CMIS_PERSONA, ORDINANCE, DISCUSSION]"}
    entityRefType: {
      label: t('user.entityRef.label', 'Entity Ref Type'),
      isOpen: false,
      accordionItems: {
        source: { label: t('source', 'Source'), value: 'SOURCE', isChecked: false },
        // matchingPersona: { label: 'Birth', value: "MATCHING_PERSONA", isChecked: false }, // Deprecated according to tf-json-binding repository
        // nonMatchingPersona: { label: 'Birth', value: "NON_MATCHING_PERSONA", isChecked: false }, // Deprecated according to tf-json-binding repository
        rejectedSourceHint: {
          label: t('user.entityRef.rejectedSourceHint', 'Rejected Source Hint'),
          value: 'REJECTED_SOURCE_HINT',
          isChecked: false,
        },
        treePerson: { label: t('user.entityRef.treePerson', 'Tree Person'), value: 'TREE_PERSON', isChecked: false },
        rejectedTreePersonHint: {
          label: t('user.entityRef.rejectedTreePersonHint', 'Rejected Tree Person Hint'),
          value: 'REJECTED_TREE_PERSON_HINT',
          isChecked: false,
        },
        memoryuser: {
          label: t('user.entityRef.memoryuser', 'Memory Person'),
          value: 'MEMORY_PERSON',
          isChecked: false,
        },
        photo: { label: t('user.entityRef.photo', 'Photo'), value: 'PHOTO', isChecked: false },
        story: { label: t('user.entityRef.story', 'Story'), value: 'STORY', isChecked: false },
        audio: { label: t('user.entityRef.audio', 'Audio'), value: 'AUDIO', isChecked: false },
        obituary: { label: t('user.entityRef.obituary', 'Obituary'), value: 'OBITUARY', isChecked: false },
        document: { label: t('user.entityRef.document', 'Document'), value: 'DOCUMENT', isChecked: false },
        userNotAMatch: {
          label: t('user.entityRef.personNotAMatch', 'Person Not A Match'),
          value: 'PERSON_NOT_A_MATCH',
          isChecked: false,
        },
        cimsusera: {
          label: t('user.entityRef.cmispersona', 'Cmis persona'),
          value: 'CMIS_PERSONA',
          isChecked: false,
        },
        ordinance: { label: t('ordinances.ordinance', 'Ordinance'), value: 'ORDINANCE', isChecked: false },
        discussion: { label: t('user.entityRef.discussion', 'Discussion'), value: 'DISCUSSION', isChecked: false },
        firstAncestor: {
          label: t('user.entityRef.firstAncestor', 'First Ancestor'),
          value: 'FIRST_ANCESTOR',
          isChecked: false,
        },
      },
    },
    // July 9, 2019 Error Message -> {"code":400,"message":"query param eventOp must be one of [PERSON_CREATED, PERSON_MERGED, PERSON_TOMBSTONED,
    // PERSON_RESTORED, PERSON_UNMERGED, CONCLUSION_ADDED, CONCLUSION_DELETED, CONCLUSION_EDITED, ENTITY_REF_ADDED, ENTITY_REF_EDITED, ENTITY_REF_DELETED,
    // RELATIONSHIP_CREATED, PERSON_ID_ESTABLISHED, PERSON_ID_CHANGED, RELATIONSHIP_TOMBSTONED, RELATIONSHIP_RESTORED]"}
    eventOp: {
      label: t('eventOp', 'Event Op'),
      isOpen: false,
      accordionItems: {
        personCreated: {
          label: t('user.eventOp.personCreated', 'Person Created'),
          value: 'PERSON_CREATED',
          isChecked: false,
        },
        personMerged: {
          label: t('user.eventOp.personMerged', 'Person Merged'),
          value: 'PERSON_MERGED',
          isChecked: false,
        },
        // personMergedComplete: { label: t('user.eventOp.personMergedComplete', 'Person Merged Complete'), value: "PERSON_MERGED_COMPLETE", isChecked: false },
        personTombstoned: {
          label: t('user.eventOp.personTombstoned', 'Person Tombstoned'),
          value: 'PERSON_TOMBSTONED',
          isChecked: false,
        },
        // personTombstonedComplete: { label: t('user.eventOp.personTombstonedComplete','Person Tombstoned Complete'), value: "PERSON_TOMBSTONED_COMPLETE", isChecked: false },
        personRestored: {
          label: t('user.eventOp.personRestored', 'Person Restored'),
          value: 'PERSON_RESTORED',
          isChecked: false,
        },
        // personRestoredComplete: { label: t('user.eventOp.personRestoredComplete', 'Person Restored Complete'), value: "PERSON_RESTORED_COMPLETE", isChecked: false },
        personUnmerged: {
          label: t('user.eventOp.personUnmerged', 'Person Unmerged'),
          value: 'PERSON_UNMERGED',
          isChecked: false,
        },
        conclusionAdded: {
          label: t('user.eventOp.conclusionAdded', 'Conclusion Added'),
          value: 'CONCLUSION_ADDED',
          isChecked: false,
        },
        conclusionDeleted: {
          label: t('user.eventOp.conclusionDeleted', 'Conclusion Deleted'),
          value: 'CONCLUSION_DELETED',
          isChecked: false,
        },
        conclusionEdited: {
          label: t('user.eventOp.conclusionEdited', 'Conclusion Edited'),
          value: 'CONCLUSION_EDITED',
          isChecked: false,
        },

        relationshipCreated: {
          label: t('user.eventOp.relationshipCreated', 'Relationship Created'),
          value: 'RELATIONSHIP_CREATED',
          isChecked: false,
        },
        personIdEstablished: {
          label: t('user.eventOp.personIdEstablished', 'Person Id Established'),
          value: 'PERSON_ID_ESTABLISHED',
          isChecked: false,
        },
        personIdChanged: {
          label: t('user.eventOp.personIdChanged', 'Person Id Changed'),
          value: 'PERSON_ID_CHANGED',
          isChecked: false,
        },
        relationshipTombstoned: {
          label: t('user.eventOp.relationshipTombstoned', 'Relationship Tombstoned'),
          value: 'RELATIONSHIP_TOMBSTONED',
          isChecked: false,
        },
        relationshipRestored: {
          label: t('user.eventOp.relationshipRestored', 'Relationship Restored'),
          value: 'RELATIONSHIP_RESTORED',
          isChecked: false,
        },
        entityRefAdded: {
          label: t('user.eventOp.entityRefAdded', 'Entity Ref Added'),
          value: 'ENTITY_REF_ADDED',
          isChecked: false,
        },
        entityRefEdited: {
          label: t('user.eventOp.entityRefEdited', 'Entity Ref Edited'),
          value: 'ENTITY_REF_EDITED',
          isChecked: false,
        },
        entityRefDeleted: {
          label: t('user.eventOp.entityRefDeleted', 'Entity ref Deleted'),
          value: 'ENTITY_REF_DELETED',
          isChecked: false,
        },
      },
    },
  }
  if (type === 'person') {
    filtersInitialState.accessControls = {
      label: t('person.accessControl.label', 'Access Controls'),
      isOpen: false,
      accordionItems: {
        boolean: { label: t('person.accessControl.label', 'Access Controls'), value: 'true', isChecked: false },
      },
    }
    filtersInitialState.contributorId = {
      label: t('contributorId', 'Contributor ID'),
      isOpen: false,
      accordionItems: {
        // This will be populated by the watcher
      },
    }
    filtersInitialState.omitContributorId = {
      label: t('omitContributorId', 'Omit Contributor ID'),
      isOpen: false,
      accordionItems: {
        // This will be populated by the watcher
      },
    }
  } else if (type === 'tree') {
    filtersInitialState.contributorId = {
      label: t('contributorId', 'Contributor ID'),
      isOpen: false,
      accordionItems: {
        // This will be populated by the watcher
      },
    }
    filtersInitialState.omitContributorId = {
      label: t('omitContributorId', 'Omit Contributor ID'),
      isOpen: false,
      accordionItems: {
        // This will be populated by the watcher
      },
    }
  }
  return filtersInitialState
}
